import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-shared-chip',
  templateUrl: './shared-chip.component.html',
  styleUrls: ['./shared-chip.component.scss'],
  standalone: false,
})
export class SharedChipComponent {

  @Input() chipId: string;
  @Input() isChipDisabled = false;
  @Input() isChipSelected = false;
  @Input() hideOverflow = false;
}
